import { Row } from '@tanstack/react-table'

import { BuildOrderForTable } from 'features/history/pages/BuildsPage/hooks/useGetBuildOrders'
import { StatusChip } from './components/StatusChip'

export const ChipCell = ({ status }: Row<BuildOrderForTable>['original']) => (
  <StatusChip status={status} />
)
